module.exports = __webpack_public_path__ + "static/img/校史馆.a1a8f5bb.png";